import createClient from '@pergas-pds/pds-api-client'
import config from '../config.js'
export default createClient(config.api)
